import 'core-js/es6/array';
import 'core-js/es7/array';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/entries';
import 'core-js/fn/object/values';
import 'core-js/fn/promise';
import 'core-js/fn/set';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';



// WEBPACK FOOTER //
// ./src/polyfills.js